import { useMap } from 'react-map-gl/maplibre';
import { useEffect } from 'react';
import { useMapSync } from './map_syncro';

/**
 * Synchronizer for MapLibre components.
 * Non-viscous direct map instance sync.
 */
export default function MapSynchronizer() {
  const { current: map } = useMap();
  const { internalRegisterMap, internalUnregisterMap } = useMapSync();

  useEffect(() => {
    if (!map) return;
    
    // Get actual maplibre map instance to attach move listener
    const mapInstance = map.getMap ? map.getMap() : map;
    
    if (internalRegisterMap) {
      internalRegisterMap(mapInstance);
    }

    return () => {
      if (internalUnregisterMap) {
        internalUnregisterMap(mapInstance);
      }
    };
  }, [map, internalRegisterMap, internalUnregisterMap]);

  return null;
}

